import { Field, FieldDescription, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { t } from "@/i18n/pl";

interface NewPasswordFieldsProps {
  newPassword: string;
  confirmPassword: string;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  disabled: boolean;
  /** Drives the destructive ring on the repeat field once validation failed. */
  invalid: boolean;
}

/**
 * New + repeat password, shared by the change-password form (settings,
 * first login) and the e-mail-code reset on the login card. The caller
 * checks length and equality before submitting.
 */
export function NewPasswordFields({
  newPassword,
  confirmPassword,
  onNewPasswordChange,
  onConfirmPasswordChange,
  disabled,
  invalid,
}: NewPasswordFieldsProps) {
  return (
    <>
      <Field>
        <FieldLabel htmlFor="new-password">{t.auth.newPassword}</FieldLabel>
        <Input
          id="new-password"
          type="password"
          autoComplete="new-password"
          required
          minLength={12}
          value={newPassword}
          onChange={(event) => onNewPasswordChange(event.target.value)}
          disabled={disabled}
        />
        <FieldDescription>{t.auth.passwordRule}</FieldDescription>
      </Field>
      <Field>
        <FieldLabel htmlFor="confirm-password">{t.auth.confirmPassword}</FieldLabel>
        <Input
          id="confirm-password"
          type="password"
          autoComplete="new-password"
          required
          value={confirmPassword}
          onChange={(event) => onConfirmPasswordChange(event.target.value)}
          disabled={disabled}
          aria-invalid={invalid}
        />
      </Field>
    </>
  );
}
